var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707070;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logout-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M673.38,1040.49H196.19a36.7,36.7,0,0,1-36.71-36.71V196.22a36.7,36.7,0,0,1,36.71-36.71H673.38a36.71,36.71,0,1,0,0-73.41H196.19A110.13,110.13,0,0,0,86.06,196.22v807.56A110.13,110.13,0,0,0,196.19,1113.9H673.38a36.71,36.71,0,1,0,0-73.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1103.2,573.94l-257-257a36.71,36.71,0,0,0-51.76,51.76L988.68,563.3h-609a36.71,36.71,0,1,0,0,73.41H989.05L794.86,830.9a36.71,36.71,0,1,0,51.76,51.76l256.95-257a36.7,36.7,0,0,0-.37-51.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1200,
    height: 1200
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.a1dba2c24a81ae3384cab356b36c1c4d.svg";
export { ForwardRef as ReactComponent };